import { isVue3 } from '../vue';

const EVENT_NAME_ACTIVATE_TAB = 'activate-tab';
const EVENT_NAME_BLUR = 'blur';
const EVENT_NAME_CANCEL = 'cancel';
const EVENT_NAME_CHANGE = 'change';
const EVENT_NAME_CHANGED = 'changed';
const EVENT_NAME_CLICK = 'click';
const EVENT_NAME_CLOSE = 'close';
const EVENT_NAME_CONTEXT = 'context';
const EVENT_NAME_CONTEXT_CHANGED = 'context-changed';
const EVENT_NAME_DESTROYED = 'destroyed';
const EVENT_NAME_DISABLE = 'disable';
const EVENT_NAME_DISABLED = 'disabled';
const EVENT_NAME_ENABLE = 'enable';
const EVENT_NAME_ENABLED = 'enabled';
const EVENT_NAME_FILTERED = 'filtered';
const EVENT_NAME_FIRST = 'first';
const EVENT_NAME_FOCUS = 'focus';
const EVENT_NAME_FOCUSIN = 'focusin';
const EVENT_NAME_FOCUSOUT = 'focusout';
const EVENT_NAME_HEAD_CLICKED = 'head-clicked';
const EVENT_NAME_HIDDEN = 'hidden';
const EVENT_NAME_HIDE = 'hide';
const EVENT_NAME_INPUT = 'input';
const EVENT_NAME_LAST = 'last';
const EVENT_NAME_MOUSEENTER = 'mouseenter';
const EVENT_NAME_MOUSELEAVE = 'mouseleave';
const EVENT_NAME_NEXT = 'next';
const EVENT_NAME_OK = 'ok';
const EVENT_NAME_OPEN = 'open';
const EVENT_NAME_PREV = 'prev';
const EVENT_NAME_REFRESH = 'refresh';
const EVENT_NAME_REFRESHED = 'refreshed';
const EVENT_NAME_ROW_CLICKED = 'row-clicked';
const EVENT_NAME_ROW_CONTEXTMENU = 'row-contextmenu';
const EVENT_NAME_ROW_DBLCLICKED = 'row-dblclicked';
const EVENT_NAME_ROW_HOVERED = 'row-hovered';
const EVENT_NAME_ROW_MIDDLE_CLICKED = 'row-middle-clicked';
const EVENT_NAME_ROW_SELECTED = 'row-selected';
const EVENT_NAME_ROW_UNHOVERED = 'row-unhovered';
const EVENT_NAME_SHOW = 'show';
const EVENT_NAME_SHOWN = 'shown';
const EVENT_NAME_SORT_CHANGED = 'sort-changed';
const EVENT_NAME_TOGGLE = 'toggle';
const EVENT_NAME_UPDATE = 'update';
const HOOK_EVENT_NAME_BEFORE_DESTROY = isVue3 ? 'vnodeBeforeUnmount' : 'hook:beforeDestroy';
const HOOK_EVENT_NAME_DESTROYED = isVue3 ? 'vNodeUnmounted' : 'hook:destroyed';
const MODEL_EVENT_NAME_PREFIX = 'update:';
const ROOT_EVENT_NAME_PREFIX = 'bv';
const ROOT_EVENT_NAME_SEPARATOR = '::';
const EVENT_OPTIONS_PASSIVE = {
  passive: true
};
const EVENT_OPTIONS_NO_CAPTURE = {
  passive: true,
  capture: false
};

export { EVENT_NAME_ACTIVATE_TAB, EVENT_NAME_BLUR, EVENT_NAME_CANCEL, EVENT_NAME_CHANGE, EVENT_NAME_CHANGED, EVENT_NAME_CLICK, EVENT_NAME_CLOSE, EVENT_NAME_CONTEXT, EVENT_NAME_CONTEXT_CHANGED, EVENT_NAME_DESTROYED, EVENT_NAME_DISABLE, EVENT_NAME_DISABLED, EVENT_NAME_ENABLE, EVENT_NAME_ENABLED, EVENT_NAME_FILTERED, EVENT_NAME_FIRST, EVENT_NAME_FOCUS, EVENT_NAME_FOCUSIN, EVENT_NAME_FOCUSOUT, EVENT_NAME_HEAD_CLICKED, EVENT_NAME_HIDDEN, EVENT_NAME_HIDE, EVENT_NAME_INPUT, EVENT_NAME_LAST, EVENT_NAME_MOUSEENTER, EVENT_NAME_MOUSELEAVE, EVENT_NAME_NEXT, EVENT_NAME_OK, EVENT_NAME_OPEN, EVENT_NAME_PREV, EVENT_NAME_REFRESH, EVENT_NAME_REFRESHED, EVENT_NAME_ROW_CLICKED, EVENT_NAME_ROW_CONTEXTMENU, EVENT_NAME_ROW_DBLCLICKED, EVENT_NAME_ROW_HOVERED, EVENT_NAME_ROW_MIDDLE_CLICKED, EVENT_NAME_ROW_SELECTED, EVENT_NAME_ROW_UNHOVERED, EVENT_NAME_SHOW, EVENT_NAME_SHOWN, EVENT_NAME_SORT_CHANGED, EVENT_NAME_TOGGLE, EVENT_NAME_UPDATE, EVENT_OPTIONS_NO_CAPTURE, EVENT_OPTIONS_PASSIVE, HOOK_EVENT_NAME_BEFORE_DESTROY, HOOK_EVENT_NAME_DESTROYED, MODEL_EVENT_NAME_PREFIX, ROOT_EVENT_NAME_PREFIX, ROOT_EVENT_NAME_SEPARATOR };
